export const messages = {
  en: {
    addCommunityPublicity: {
      title: 'Add Community Publicity',
      pubTitle: 'Publicity Title',
      pubType: 'Publicity Type',
      headerPhoto: 'Header Photo',
      activityContent: 'Activity Content',
      back: 'Back',
      submit: 'Submit',
      requiredTitle: 'Required, please fill in the publicity title',
      requiredType: 'Required, please select publicity type',
      requiredContent: 'Required, please enter announcement content',
      requiredHeaderPhoto: 'Required, please upload header photo'
    }
  },
  zh: {
    addCommunityPublicity: {
      title: '添加社区公示',
      pubTitle: '公示标题',
      pubType: '公示类型',
      headerPhoto: '头部照片',
      activityContent: '活动内容',
      back: '返回',
      submit: '提交',
      requiredTitle: '必填，请填写公示标题',
      requiredType: '必填，请选择公示类型',
      requiredContent: '必填，请输入公告内容',
requiredHeaderPhoto: '必填，请上传头部照片'
    }
  },
  'zh-TW': {
    addCommunityPublicity: {
      title: '添加社區公示',
      pubTitle: '公示標題',
      pubType: '公示類型',
      headerPhoto: '頭部照片',
      activityContent: '活動內容',
      back: '返回',
      submit: '提交',
      requiredTitle: '必填，請填寫公示標題',
      requiredType: '必填，請選擇公示類型',
      requiredContent: '必填，請輸入公告內容',
      requiredHeaderPhoto: '必填，請上傳頭部照片'
    }
  }
}